var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"works"}},[_c('div',{staticClass:"port_open"},[_vm._v("WORKS")]),_c('div',{staticClass:"worksPreview"},_vm._l((_vm.lavori),function(lavoro){return _c('WorkPreview',{key:lavoro.id,attrs:{"lavoro":lavoro}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }